import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import { useAppDispatch } from '../../app/hooks';
import { setPageName } from '../../app/appSlice';

const AdminView = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setPageName(''));
  });
  return <Typography>welcome to the admin view</Typography>;
};

export default AdminView;
